import { Loading } from "@/layouts/loading";
import { createFileRoute } from "@tanstack/react-router";

const AccountsComponent = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Company Accounts</h1>
      <div className="bg-white p-6 rounded-lg border shadow-sm">
        <h2 className="text-xl font-semibold mb-4">Financial Management</h2>
        <p className="text-gray-600 mb-4">
          Manage company-wide financial accounts, budgets, and transactions.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="bg-green-50 p-4 rounded-lg">
            <h3 className="font-semibold text-green-900 mb-2">Revenue Accounts</h3>
            <p className="text-sm text-green-700">Track income from all branches</p>
          </div>
          <div className="bg-red-50 p-4 rounded-lg">
            <h3 className="font-semibold text-red-900 mb-2">Expense Accounts</h3>
            <p className="text-sm text-red-700">Monitor operational expenses</p>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg">
            <h3 className="font-semibold text-blue-900 mb-2">Asset Accounts</h3>
            <p className="text-sm text-blue-700">Manage company assets and investments</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Route = createFileRoute('/company/_layout/accounts/')({
  component: AccountsComponent,
  pendingComponent: () => <Loading />,
})
